import { render, staticRenderFns } from "./GoBackButton.vue?vue&type=template&id=74a9b9a9"
import script from "./GoBackButton.vue?vue&type=script&lang=js"
export * from "./GoBackButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports